{
  "cycle": "202618",
  "accessed": "2026-09-12",
  "files": {
    "national": {
      "url": "https://www.census.gov/hfp/btos/downloads/National.xlsx",
      "sha256": "16487a7d419f556d33da63da289a79868755405fbcd1f30cb9917b4cf897cf35"
    },
    "sector": {
      "url": "https://www.census.gov/hfp/btos/downloads/Sector.xlsx",
      "sha256": "39dbb5a89375ccbe1246ff78ed15c8cd1849a9f9e730238e2f46e11384938b16"
    },
    "state": {
      "url": "https://www.census.gov/hfp/btos/downloads/State.xlsx",
      "sha256": "d43a68ab4188afa9844c0d1f5fd86e023ba0935e2d7462c59ea15139a727638f"
    },
    "size": {
      "url": "https://www.census.gov/hfp/btos/downloads/Employment%20Size%20Class.xlsx",
      "sha256": "698f03679e1f9a52b59c2a76b886144a54934c2fc525d871f57877607db531a1"
    }
  },
  "groups": {
    "national": [
      {
        "code": "US",
        "question": 7,
        "value": 23.2,
        "standardError": 0.28,
        "cell": "E16"
      },
      {
        "code": "US",
        "question": 24,
        "value": 27.3,
        "standardError": 0.28,
        "cell": "E82"
      }
    ],
    "sector": [
      {
        "code": "11",
        "question": 7,
        "value": null,
        "standardError": null,
        "cell": "F16"
      },
      {
        "code": "11",
        "question": 24,
        "value": null,
        "standardError": null,
        "cell": "F82"
      },
      {
        "code": "21",
        "question": 7,
        "value": 5.3,
        "standardError": 2.05,
        "cell": "F99"
      },
      {
        "code": "21",
        "question": 24,
        "value": 8.4,
        "standardError": 2.88,
        "cell": "F165"
      },
      {
        "code": "22",
        "question": 7,
        "value": 16.4,
        "standardError": 3.4,
        "cell": "F182"
      },
      {
        "code": "22",
        "question": 24,
        "value": 18.0,
        "standardError": 5.09,
        "cell": "F248"
      },
      {
        "code": "23",
        "question": 7,
        "value": 16.0,
        "standardError": 0.9,
        "cell": "F265"
      },
      {
        "code": "23",
        "question": 24,
        "value": 18.1,
        "standardError": 0.83,
        "cell": "F331"
      },
      {
        "code": "31",
        "question": 7,
        "value": 23.4,
        "standardError": 0.98,
        "cell": "F348"
      },
      {
        "code": "31",
        "question": 24,
        "value": 26.1,
        "standardError": 0.87,
        "cell": "F414"
      },
      {
        "code": "42",
        "question": 7,
        "value": 20.4,
        "standardError": 1.06,
        "cell": "F431"
      },
      {
        "code": "42",
        "question": 24,
        "value": 24.8,
        "standardError": 1.34,
        "cell": "F497"
      },
      {
        "code": "44",
        "question": 7,
        "value": 15.5,
        "standardError": 0.97,
        "cell": "F514"
      },
      {
        "code": "44",
        "question": 24,
        "value": 19.3,
        "standardError": 1.17,
        "cell": "F580"
      },
      {
        "code": "48",
        "question": 7,
        "value": 7.9,
        "standardError": 1.0,
        "cell": "F597"
      },
      {
        "code": "48",
        "question": 24,
        "value": 11.5,
        "standardError": 1.36,
        "cell": "F663"
      },
      {
        "code": "51",
        "question": 7,
        "value": 43.5,
        "standardError": 1.59,
        "cell": "F680"
      },
      {
        "code": "51",
        "question": 24,
        "value": 49.1,
        "standardError": 1.77,
        "cell": "F746"
      },
      {
        "code": "52",
        "question": 7,
        "value": 36.5,
        "standardError": 2.29,
        "cell": "F763"
      },
      {
        "code": "52",
        "question": 24,
        "value": 43.8,
        "standardError": 2.26,
        "cell": "F829"
      },
      {
        "code": "53",
        "question": 7,
        "value": 31.9,
        "standardError": 1.45,
        "cell": "F846"
      },
      {
        "code": "53",
        "question": 24,
        "value": 37.7,
        "standardError": 1.47,
        "cell": "F912"
      },
      {
        "code": "54",
        "question": 7,
        "value": 43.3,
        "standardError": 0.96,
        "cell": "F929"
      },
      {
        "code": "54",
        "question": 24,
        "value": 48.5,
        "standardError": 0.64,
        "cell": "F995"
      },
      {
        "code": "55",
        "question": 7,
        "value": 34.8,
        "standardError": 16.06,
        "cell": "F1012"
      },
      {
        "code": "55",
        "question": 24,
        "value": 27.3,
        "standardError": 11.93,
        "cell": "F1078"
      },
      {
        "code": "56",
        "question": 7,
        "value": 20.7,
        "standardError": 1.29,
        "cell": "F1095"
      },
      {
        "code": "56",
        "question": 24,
        "value": 24.9,
        "standardError": 1.15,
        "cell": "F1161"
      },
      {
        "code": "61",
        "question": 7,
        "value": 35.5,
        "standardError": 2.08,
        "cell": "F1178"
      },
      {
        "code": "61",
        "question": 24,
        "value": 38.8,
        "standardError": 2.37,
        "cell": "F1244"
      },
      {
        "code": "62",
        "question": 7,
        "value": 24.7,
        "standardError": 0.79,
        "cell": "F1261"
      },
      {
        "code": "62",
        "question": 24,
        "value": 29.7,
        "standardError": 1.02,
        "cell": "F1327"
      },
      {
        "code": "71",
        "question": 7,
        "value": 20.0,
        "standardError": 1.76,
        "cell": "F1344"
      },
      {
        "code": "71",
        "question": 24,
        "value": 22.3,
        "standardError": 1.38,
        "cell": "F1410"
      },
      {
        "code": "72",
        "question": 7,
        "value": 8.5,
        "standardError": 0.59,
        "cell": "F1427"
      },
      {
        "code": "72",
        "question": 24,
        "value": 11.8,
        "standardError": 0.65,
        "cell": "F1493"
      },
      {
        "code": "81",
        "question": 7,
        "value": 13.7,
        "standardError": 0.36,
        "cell": "F1510"
      },
      {
        "code": "81",
        "question": 24,
        "value": 16.9,
        "standardError": 0.44,
        "cell": "F1576"
      },
      {
        "code": "XX",
        "question": 7,
        "value": 38.2,
        "standardError": 2.5,
        "cell": "F1593"
      },
      {
        "code": "XX",
        "question": 24,
        "value": 43.1,
        "standardError": 3.48,
        "cell": "F1659"
      }
    ],
    "state": [
      {
        "code": "AK",
        "question": 7,
        "value": 12.7,
        "standardError": 3.28,
        "cell": "F16"
      },
      {
        "code": "AK",
        "question": 24,
        "value": 17.9,
        "standardError": 5.06,
        "cell": "F82"
      },
      {
        "code": "AL",
        "question": 7,
        "value": 13.4,
        "standardError": 2.53,
        "cell": "F99"
      },
      {
        "code": "AL",
        "question": 24,
        "value": 17.8,
        "standardError": 2.3,
        "cell": "F165"
      },
      {
        "code": "AR",
        "question": 7,
        "value": 21.3,
        "standardError": 1.69,
        "cell": "F182"
      },
      {
        "code": "AR",
        "question": 24,
        "value": 23.9,
        "standardError": 2.14,
        "cell": "F248"
      },
      {
        "code": "AZ",
        "question": 7,
        "value": 28.7,
        "standardError": 2.63,
        "cell": "F265"
      },
      {
        "code": "AZ",
        "question": 24,
        "value": 31.0,
        "standardError": 1.68,
        "cell": "F331"
      },
      {
        "code": "CA",
        "question": 7,
        "value": 25.1,
        "standardError": 0.65,
        "cell": "F348"
      },
      {
        "code": "CA",
        "question": 24,
        "value": 28.4,
        "standardError": 0.84,
        "cell": "F414"
      },
      {
        "code": "CO",
        "question": 7,
        "value": 25.0,
        "standardError": 2.12,
        "cell": "F431"
      },
      {
        "code": "CO",
        "question": 24,
        "value": 30.5,
        "standardError": 3.28,
        "cell": "F497"
      },
      {
        "code": "CT",
        "question": 7,
        "value": 17.3,
        "standardError": 2.24,
        "cell": "F514"
      },
      {
        "code": "CT",
        "question": 24,
        "value": 21.5,
        "standardError": 3.04,
        "cell": "F580"
      },
      {
        "code": "DC",
        "question": 7,
        "value": 24.6,
        "standardError": 3.08,
        "cell": "F597"
      },
      {
        "code": "DC",
        "question": 24,
        "value": 28.3,
        "standardError": 3.37,
        "cell": "F663"
      },
      {
        "code": "DE",
        "question": 7,
        "value": 35.8,
        "standardError": 5.09,
        "cell": "F680"
      },
      {
        "code": "DE",
        "question": 24,
        "value": 39.3,
        "standardError": 5.33,
        "cell": "F746"
      },
      {
        "code": "FL",
        "question": 7,
        "value": 28.2,
        "standardError": 1.31,
        "cell": "F763"
      },
      {
        "code": "FL",
        "question": 24,
        "value": 33.3,
        "standardError": 1.38,
        "cell": "F829"
      },
      {
        "code": "GA",
        "question": 7,
        "value": 25.6,
        "standardError": 2.48,
        "cell": "F846"
      },
      {
        "code": "GA",
        "question": 24,
        "value": 31.2,
        "standardError": 2.08,
        "cell": "F912"
      },
      {
        "code": "HI",
        "question": 7,
        "value": 20.1,
        "standardError": 2.72,
        "cell": "F929"
      },
      {
        "code": "HI",
        "question": 24,
        "value": 26.2,
        "standardError": 4.88,
        "cell": "F995"
      },
      {
        "code": "IA",
        "question": 7,
        "value": 21.5,
        "standardError": 3.08,
        "cell": "F1012"
      },
      {
        "code": "IA",
        "question": 24,
        "value": 25.0,
        "standardError": 3.33,
        "cell": "F1078"
      },
      {
        "code": "ID",
        "question": 7,
        "value": 24.4,
        "standardError": 2.93,
        "cell": "F1095"
      },
      {
        "code": "ID",
        "question": 24,
        "value": 29.3,
        "standardError": 3.27,
        "cell": "F1161"
      },
      {
        "code": "IL",
        "question": 7,
        "value": 23.3,
        "standardError": 0.79,
        "cell": "F1178"
      },
      {
        "code": "IL",
        "question": 24,
        "value": 27.4,
        "standardError": 1.45,
        "cell": "F1244"
      },
      {
        "code": "IN",
        "question": 7,
        "value": 18.4,
        "standardError": 1.36,
        "cell": "F1261"
      },
      {
        "code": "IN",
        "question": 24,
        "value": 22.8,
        "standardError": 1.9,
        "cell": "F1327"
      },
      {
        "code": "KS",
        "question": 7,
        "value": 19.0,
        "standardError": 2.99,
        "cell": "F1344"
      },
      {
        "code": "KS",
        "question": 24,
        "value": 23.4,
        "standardError": 3.29,
        "cell": "F1410"
      },
      {
        "code": "KY",
        "question": 7,
        "value": 21.7,
        "standardError": 2.81,
        "cell": "F1427"
      },
      {
        "code": "KY",
        "question": 24,
        "value": 22.1,
        "standardError": 2.2,
        "cell": "F1493"
      },
      {
        "code": "LA",
        "question": 7,
        "value": 19.2,
        "standardError": 2.0,
        "cell": "F1510"
      },
      {
        "code": "LA",
        "question": 24,
        "value": 23.7,
        "standardError": 2.55,
        "cell": "F1576"
      },
      {
        "code": "MA",
        "question": 7,
        "value": 27.7,
        "standardError": 1.88,
        "cell": "F1593"
      },
      {
        "code": "MA",
        "question": 24,
        "value": 29.5,
        "standardError": 1.39,
        "cell": "F1659"
      },
      {
        "code": "MD",
        "question": 7,
        "value": 21.9,
        "standardError": 2.68,
        "cell": "F1676"
      },
      {
        "code": "MD",
        "question": 24,
        "value": 25.9,
        "standardError": 2.52,
        "cell": "F1742"
      },
      {
        "code": "ME",
        "question": 7,
        "value": 26.2,
        "standardError": 4.21,
        "cell": "F1759"
      },
      {
        "code": "ME",
        "question": 24,
        "value": 26.2,
        "standardError": 4.35,
        "cell": "F1825"
      },
      {
        "code": "MI",
        "question": 7,
        "value": 24.8,
        "standardError": 1.13,
        "cell": "F1842"
      },
      {
        "code": "MI",
        "question": 24,
        "value": 28.9,
        "standardError": 1.34,
        "cell": "F1908"
      },
      {
        "code": "MN",
        "question": 7,
        "value": 21.1,
        "standardError": 2.68,
        "cell": "F1925"
      },
      {
        "code": "MN",
        "question": 24,
        "value": 27.7,
        "standardError": 2.95,
        "cell": "F1991"
      },
      {
        "code": "MO",
        "question": 7,
        "value": 21.7,
        "standardError": 2.43,
        "cell": "F2008"
      },
      {
        "code": "MO",
        "question": 24,
        "value": 25.3,
        "standardError": 2.31,
        "cell": "F2074"
      },
      {
        "code": "MS",
        "question": 7,
        "value": 11.5,
        "standardError": 2.66,
        "cell": "F2091"
      },
      {
        "code": "MS",
        "question": 24,
        "value": 14.6,
        "standardError": 3.54,
        "cell": "F2157"
      },
      {
        "code": "MT",
        "question": 7,
        "value": 16.2,
        "standardError": 3.48,
        "cell": "F2174"
      },
      {
        "code": "MT",
        "question": 24,
        "value": 22.5,
        "standardError": 2.43,
        "cell": "F2240"
      },
      {
        "code": "NC",
        "question": 7,
        "value": 25.4,
        "standardError": 1.63,
        "cell": "F2257"
      },
      {
        "code": "NC",
        "question": 24,
        "value": 28.4,
        "standardError": 1.9,
        "cell": "F2323"
      },
      {
        "code": "ND",
        "question": 7,
        "value": 20.6,
        "standardError": 3.6,
        "cell": "F2340"
      },
      {
        "code": "ND",
        "question": 24,
        "value": 21.3,
        "standardError": 3.46,
        "cell": "F2406"
      },
      {
        "code": "NE",
        "question": 7,
        "value": 16.9,
        "standardError": 3.31,
        "cell": "F2423"
      },
      {
        "code": "NE",
        "question": 24,
        "value": 22.1,
        "standardError": 2.96,
        "cell": "F2489"
      },
      {
        "code": "NH",
        "question": 7,
        "value": 13.3,
        "standardError": 4.47,
        "cell": "F2506"
      },
      {
        "code": "NH",
        "question": 24,
        "value": 16.2,
        "standardError": 4.82,
        "cell": "F2572"
      },
      {
        "code": "NJ",
        "question": 7,
        "value": 16.4,
        "standardError": 1.36,
        "cell": "F2589"
      },
      {
        "code": "NJ",
        "question": 24,
        "value": 20.1,
        "standardError": 1.31,
        "cell": "F2655"
      },
      {
        "code": "NM",
        "question": 7,
        "value": 21.4,
        "standardError": 2.58,
        "cell": "F2672"
      },
      {
        "code": "NM",
        "question": 24,
        "value": 28.4,
        "standardError": 2.39,
        "cell": "F2738"
      },
      {
        "code": "NV",
        "question": 7,
        "value": 30.3,
        "standardError": 2.19,
        "cell": "F2755"
      },
      {
        "code": "NV",
        "question": 24,
        "value": 30.3,
        "standardError": 2.71,
        "cell": "F2821"
      },
      {
        "code": "NY",
        "question": 7,
        "value": 17.0,
        "standardError": 0.94,
        "cell": "F2838"
      },
      {
        "code": "NY",
        "question": 24,
        "value": 21.5,
        "standardError": 0.79,
        "cell": "F2904"
      },
      {
        "code": "OH",
        "question": 7,
        "value": 20.6,
        "standardError": 1.62,
        "cell": "F2921"
      },
      {
        "code": "OH",
        "question": 24,
        "value": 24.8,
        "standardError": 1.64,
        "cell": "F2987"
      },
      {
        "code": "OK",
        "question": 7,
        "value": 17.1,
        "standardError": 2.15,
        "cell": "F3004"
      },
      {
        "code": "OK",
        "question": 24,
        "value": 19.2,
        "standardError": 2.92,
        "cell": "F3070"
      },
      {
        "code": "OR",
        "question": 7,
        "value": 22.6,
        "standardError": 2.23,
        "cell": "F3087"
      },
      {
        "code": "OR",
        "question": 24,
        "value": 25.7,
        "standardError": 1.94,
        "cell": "F3153"
      },
      {
        "code": "PA",
        "question": 7,
        "value": 19.0,
        "standardError": 1.58,
        "cell": "F3170"
      },
      {
        "code": "PA",
        "question": 24,
        "value": 22.9,
        "standardError": 2.12,
        "cell": "F3236"
      },
      {
        "code": "PR",
        "question": 7,
        "value": 14.4,
        "standardError": 2.54,
        "cell": "F3253"
      },
      {
        "code": "PR",
        "question": 24,
        "value": 25.8,
        "standardError": 3.75,
        "cell": "F3319"
      },
      {
        "code": "RI",
        "question": 7,
        "value": 10.9,
        "standardError": 2.69,
        "cell": "F3336"
      },
      {
        "code": "RI",
        "question": 24,
        "value": 17.3,
        "standardError": 4.53,
        "cell": "F3402"
      },
      {
        "code": "SC",
        "question": 7,
        "value": 23.9,
        "standardError": 2.74,
        "cell": "F3419"
      },
      {
        "code": "SC",
        "question": 24,
        "value": 29.4,
        "standardError": 3.04,
        "cell": "F3485"
      },
      {
        "code": "SD",
        "question": 7,
        "value": 17.8,
        "standardError": 4.16,
        "cell": "F3502"
      },
      {
        "code": "SD",
        "question": 24,
        "value": 26.3,
        "standardError": 6.14,
        "cell": "F3568"
      },
      {
        "code": "TN",
        "question": 7,
        "value": 23.1,
        "standardError": 1.59,
        "cell": "F3585"
      },
      {
        "code": "TN",
        "question": 24,
        "value": 26.7,
        "standardError": 1.6,
        "cell": "F3651"
      },
      {
        "code": "TX",
        "question": 7,
        "value": 25.2,
        "standardError": 0.89,
        "cell": "F3668"
      },
      {
        "code": "TX",
        "question": 24,
        "value": 29.5,
        "standardError": 0.95,
        "cell": "F3734"
      },
      {
        "code": "UT",
        "question": 7,
        "value": 33.7,
        "standardError": 1.76,
        "cell": "F3751"
      },
      {
        "code": "UT",
        "question": 24,
        "value": 39.2,
        "standardError": 2.1,
        "cell": "F3817"
      },
      {
        "code": "VA",
        "question": 7,
        "value": 27.1,
        "standardError": 1.29,
        "cell": "F3834"
      },
      {
        "code": "VA",
        "question": 24,
        "value": 29.7,
        "standardError": 1.45,
        "cell": "F3900"
      },
      {
        "code": "VT",
        "question": 7,
        "value": 23.9,
        "standardError": 6.05,
        "cell": "F3917"
      },
      {
        "code": "VT",
        "question": 24,
        "value": 26.7,
        "standardError": 4.69,
        "cell": "F3983"
      },
      {
        "code": "WA",
        "question": 7,
        "value": 25.7,
        "standardError": 1.61,
        "cell": "F4000"
      },
      {
        "code": "WA",
        "question": 24,
        "value": 30.2,
        "standardError": 1.84,
        "cell": "F4066"
      },
      {
        "code": "WI",
        "question": 7,
        "value": 21.0,
        "standardError": 1.55,
        "cell": "F4083"
      },
      {
        "code": "WI",
        "question": 24,
        "value": 25.8,
        "standardError": 1.32,
        "cell": "F4149"
      },
      {
        "code": "WV",
        "question": 7,
        "value": 8.7,
        "standardError": 2.25,
        "cell": "F4166"
      },
      {
        "code": "WV",
        "question": 24,
        "value": 11.1,
        "standardError": 3.09,
        "cell": "F4232"
      },
      {
        "code": "WY",
        "question": 7,
        "value": 21.1,
        "standardError": 4.65,
        "cell": "F4249"
      },
      {
        "code": "WY",
        "question": 24,
        "value": 28.4,
        "standardError": 6.56,
        "cell": "F4315"
      },
      {
        "code": "XX",
        "question": 7,
        "value": 38.5,
        "standardError": 1.7,
        "cell": "F4332"
      },
      {
        "code": "XX",
        "question": 24,
        "value": 47.4,
        "standardError": 2.45,
        "cell": "F4398"
      }
    ],
    "size": [
      {
        "code": "A",
        "question": 7,
        "value": 23.6,
        "standardError": 0.47,
        "cell": "F16"
      },
      {
        "code": "A",
        "question": 24,
        "value": 27.3,
        "standardError": 0.48,
        "cell": "F82"
      },
      {
        "code": "B",
        "question": 7,
        "value": 21.0,
        "standardError": 0.43,
        "cell": "F99"
      },
      {
        "code": "B",
        "question": 24,
        "value": 25.4,
        "standardError": 0.55,
        "cell": "F165"
      },
      {
        "code": "C",
        "question": 7,
        "value": 20.8,
        "standardError": 0.67,
        "cell": "F182"
      },
      {
        "code": "C",
        "question": 24,
        "value": 25.1,
        "standardError": 0.53,
        "cell": "F248"
      },
      {
        "code": "D",
        "question": 7,
        "value": 23.3,
        "standardError": 0.8,
        "cell": "F265"
      },
      {
        "code": "D",
        "question": 24,
        "value": 28.8,
        "standardError": 0.76,
        "cell": "F331"
      },
      {
        "code": "E",
        "question": 7,
        "value": 25.8,
        "standardError": 1.08,
        "cell": "F348"
      },
      {
        "code": "E",
        "question": 24,
        "value": 31.8,
        "standardError": 1.12,
        "cell": "F414"
      },
      {
        "code": "F",
        "question": 7,
        "value": 34.5,
        "standardError": 2.37,
        "cell": "F431"
      },
      {
        "code": "F",
        "question": 24,
        "value": 40.4,
        "standardError": 2.72,
        "cell": "F497"
      },
      {
        "code": "G",
        "question": 7,
        "value": 38.4,
        "standardError": 2.58,
        "cell": "F514"
      },
      {
        "code": "G",
        "question": 24,
        "value": 46.6,
        "standardError": 3.43,
        "cell": "F580"
      }
    ]
  },
  "referenceStart": "2026-08-10",
  "referenceEnd": "2026-08-23",
  "collectionStart": "2026-08-24",
  "collectionEnd": "2026-09-06",
  "published": "2026-09-10"
}
